import React, { Component } from 'react'
import './AdminGroupMembers.css'
import { BtnPrimary, BtnSecondary } from '../commons/Buttons'
import { database, ref, get, set, child } from '../../firebase'
import Loading from '../commons/Loading'
import Members from './Members.jsx'

class AdminGroupMembers extends Component {
  constructor (props) {
    super(props)
    this.state = {
      members: [],
      currentMembers: [],
      activity: null
    }
    this.getData = this.getData.bind(this)
    this.addMembers = this.addMembers.bind(this)
    this.deleteMembers = this.deleteMembers.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }
  componentDidMount () {
    this.getData()
      .then((data) => {
        this.setState((prevState) => ({
          members: prevState.members.concat(data),
          currentMembers: prevState.members.concat(data)
        }))
      })
      .catch((err) => console.error(err))
  }
  onSubmit () {
    this.setState({
      activity: true
    })
    const members = this.state.members.map((member) => member.id)
    const currentMembers = this.state.currentMembers.map((member) => member.id)
    const deleteMembers = currentMembers.filter((member) => !members.includes(member))
    const addMembers = members.filter((member) => !currentMembers.includes(member))
    this.deleteMembers(deleteMembers)
      .then(() => {
        return this.addMembers(addMembers)
      })
      .then(() => {
        this.setState({
          activity: null
        })
        this.props.closeModal()
        setTimeout(() => window.location.reload(), 800)
      })
      .catch((err) => {
        console.error(err)
      })
  }
  getData () {
    return new Promise((resolve, reject) => {
      const members = []
      get(ref(database, 'grupos/miembros/' + this.props.groupId))
        .then((snap) => {
          const promises = []
          let count = 0
          snap.forEach((childSnapshot) => {
            if (childSnapshot.key !== this.props.userId) {
              promises[count] = new Promise((resolve, reject) => {
                get(child(ref(database, 'usuarios/index'), childSnapshot.key))
                  .then((snap) => {
                    members.push({
                      id: snap.key,
                      name: snap.val().name,
                      photo: snap.val().photo
                    })
                    resolve()
                  })
                  .catch((err) => reject(err))
              })
              count++
            }
          })
          return Promise.all(promises)
        })
        .then((snap) => {
          members.sort((a, b) => a.name.localeCompare(b.name))
          resolve(members)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  deleteMembers (members) {
    return new Promise((resolve, reject) => {
      const promises = []
      let count = 0
      members.forEach((member) => {
        promises[count] = new Promise((resolve, reject) => {
          set(child(ref(database, 'grupos/miembros/' + this.props.groupId), member), null)
            .then(() => {
              return set(ref(database, 'usuarios/grupos/' + member + '/' + this.props.groupId), null)
            })
            .then(() => {
              return set(ref(database, 'grupos/puntaje/' + this.props.groupId + '/global/' + member), null)
            })
            .then(() => {
              resolve()
            })
            .catch((err) => reject(err))
        })
        count++
      })
      Promise.all(promises)
        .then(() => {
          resolve()
        })
        .catch((err) => reject(err))
    })
  }
  addMembers (members) {
    return new Promise((resolve, reject) => {
      const promises = []
      let count = 0
      members.forEach((member) => {
        promises[count] = new Promise((resolve, reject) => {
          set(ref(database, 'grupos/miembros/' + this.props.groupId + '/' + member), true)
            .then(() => {
              return set(ref(database, 'grupos/puntaje/' + this.props.groupId + '/global/' + member), 0)
            })
            .then(() => {
              return set(ref(database, 'usuarios/grupos/' + member + '/' + this.props.groupId), true)
            })
            .then(() => {
              resolve()
            })
            .catch((err) => reject(err))
        })
        count++
      })
      Promise.all(promises)
        .then(() => {
          resolve()
        })
        .catch((err) => reject(err))
    })
  }
  render () {
    return (
      <div className='admin-group-members'>
        <p>Has cambios en la alineación, agrega o expulsa miembros del grupo. Solo recuerda, si la quiniela está en juego y entra un nuevo usuario, su puntaje empezará desde 0. </p>
        {this.state.members && <Members admin={this.props.userId} members={this.state.members} handleMembers={(members) => this.setState({ members: members })} />}
        <div className='admin-group-members__row'>
          <div className='admin-group-members__col'>
            <BtnSecondary onClick={() => this.props.closeModal()}>Cancelar</BtnSecondary>
          </div>
          <div className='admin-group-members__col'>
            <BtnPrimary onClick={() => this.onSubmit()}>{this.props.activity ? <Loading /> : 'Hecho'}</BtnPrimary>
          </div>
        </div>
      </div>
    )
  }
}

export default AdminGroupMembers
